var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-trash-alt",
    "data-name": "Icon awesome-trash-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.963,
    height: 24,
    viewBox: "0 0 22.963 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trash-alt-2",
    "data-name": "Icon awesome-trash-alt",
    d: "M1.64,21.75A2.362,2.362,0,0,0,4.1,24H18.863a2.362,2.362,0,0,0,2.46-2.25V6H1.64Zm13.942-12a.823.823,0,0,1,1.64,0v10.5a.823.823,0,0,1-1.64,0Zm-4.921,0a.823.823,0,0,1,1.64,0v10.5a.823.823,0,0,1-1.64,0Zm-4.921,0A.787.787,0,0,1,6.561,9a.787.787,0,0,1,.82.75v10.5a.787.787,0,0,1-.82.75.787.787,0,0,1-.82-.75Zm16.4-8.25H15.992L15.51.623A1.247,1.247,0,0,0,14.408,0H8.55a1.231,1.231,0,0,0-1.1.623L6.971,1.5H.82A.787.787,0,0,0,0,2.25v1.5a.787.787,0,0,0,.82.75H22.143a.787.787,0,0,0,.82-.75V2.25A.787.787,0,0,0,22.143,1.5Z",
    fill: "#bf0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.eeda93bfaf6186138ddbc1b80f604909.svg";
export { ForwardRef as ReactComponent };